var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-box"},[_c('button',{staticClass:"minus",on:{"click":_vm.handleSub}},[_vm._v("-")]),_c('input',{staticClass:"inp",attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"change":_vm.handleChange}}),_c('button',{staticClass:"add",on:{"click":_vm.handleAdd}},[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }